// Import Actions
import {
  orderBy, findIndex, reject as lodashReject, reduce,
  indexOf, each,
} from 'lodash';
import {
  TOGGLE_ADD_POST, LOAD_USER_PREFERENCE, UPDATE_USER_PREFERENCE,
  WINDOW_DIMENSIONS, HEADER_HEIGHT, FOOTER_HEIGHT, CONTAINER_WIDTH,
  LOAD_TABLE_PREFERENCES, LOAD_TABLE_PREFERENCE,
  ADD_TABLE_PREFERENCE_COLUMN, UPDATE_TABLE_PREFERENCE_COLUMN,
  DELETE_TABLE_PREFERENCE_COLUMN,
  UPDATE_TABLE_PREFERENCE_COLUMN_POSITIONS,
  LOAD_TABLE_PREFERENCE_META_DATA,
  LOAD_USER_SYNC_PERMISSIONS,
  LOAD_ORGANIZATION_SYNC_PERMISSIONS,
  APP_HIDE_SYNC_TOAST,
  APP_UNHIDE_SYNC_TOAST,
  APP_SHOULD_SHOW_SYNC_TOAST,
  APP_SHOULD_HIDE_SYNC_TOAST,
} from './AppActions';
import { getCookie } from '../../util/apiCaller';
import {
  CUSTOM_META_ADD_NEW_META,
} from '../../components/custom-meta/actions';

export const USER_PREFERENCE_FONT_SIZE = 'font-size';
export const FONT_SIZE_NORMAL = 1;
export const FONT_SIZE_BIG = 2;
// export const FONT_SIZE_HUGE = 3;
export const FONT_SIZES = [FONT_SIZE_NORMAL, FONT_SIZE_BIG];

// Initial State
const initialState = {
  showAddPost: false,
  isPhantomJS: false,
  isReadyForPhantomJS: false,
  preferences: {},
  tablePreferences: {},
  tablePreferenceMetaData: [],
  hideSyncToast: false,
  shouldShowSyncToast: false,
  dimensions: {
    windowWidth: 0,
    windowHeight: 0,
    containerWidth: 0,
    headerHeight: 0,
    footerHeight: 0,
  },
  userSyncPermissions: {
    // indexed by user._id
  },
  organizationSyncPermissions: {
    // indexed by organization._id
  },
};

const AppReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_ADD_POST:
      return { ...state, showAddPost: !state.showAddPost };
    case WINDOW_DIMENSIONS:
      return { ...state, dimensions: { ...state.dimensions, windowWidth: action.width, windowHeight: action.height } };
    case HEADER_HEIGHT:
      return { ...state, dimensions: { ...state.dimensions, headerHeight: action.height } };
    case FOOTER_HEIGHT:
      return { ...state, dimensions: { ...state.dimensions, footerHeight: action.height } };
    case CONTAINER_WIDTH:
      return { ...state, dimensions: { ...state.dimensions, containerWidth: action.width } };
    case LOAD_USER_PREFERENCE:
      return { ...state, preferences: action.preferences };
    case UPDATE_USER_PREFERENCE: {
      const { preferences } = state;
      const { preference } = action;
      const newPreferences = { ...preferences, [preference.name]: preference.value };
      return { ...state, preferences: newPreferences };
    }
    case LOAD_TABLE_PREFERENCES: {
      const { preferences } = action;
      return { ...state, tablePreferences: preferences };
    }
    case LOAD_TABLE_PREFERENCE: {
      const { tablePreferences } = state;
      const { columns, tableName } = action;
      const newPreferences = { ...tablePreferences, [tableName]: columns };
      return { ...state, tablePreferences: newPreferences };
    }
    case ADD_TABLE_PREFERENCE_COLUMN: {
      const { tablePreferences } = state;
      const { column, tableName } = action;
      const currentPreference = tablePreferences[tableName];
      if (currentPreference) {
        const newColumns = orderBy(currentPreference.concat(column), ['position']);
        const newPreferences = {
          ...tablePreferences,
          [tableName]: newColumns,
        };
        return { ...state, tablePreferences: newPreferences };
      }
      return state;
    }
    case UPDATE_TABLE_PREFERENCE_COLUMN: {
      const { tablePreferences } = state;
      const { column, tableName, id } = action;
      const currentPreference = tablePreferences[tableName];
      if (currentPreference) {
        const currentColumnIndex = findIndex(currentPreference, { _id: id });
        if (currentColumnIndex >= 0) {
          const newColumns = [...currentPreference];
          newColumns[currentColumnIndex] = column;
          const newPreferences = {
            ...tablePreferences,
            [tableName]: orderBy(newColumns, ['position']),
          };
          return { ...state, tablePreferences: newPreferences };
        }
      }
      return state;
    }
    case DELETE_TABLE_PREFERENCE_COLUMN: {
      const { tablePreferences } = state;
      const { tableName, id } = action;
      const currentPreference = tablePreferences[tableName];
      if (currentPreference) {
        const newColumns = lodashReject(currentPreference, { _id: id });
        const newPreferences = {
          ...tablePreferences,
          [tableName]: orderBy(newColumns, ['position']),
        };
        return { ...state, tablePreferences: newPreferences };
      }
      return state;
    }
    case UPDATE_TABLE_PREFERENCE_COLUMN_POSITIONS: {
      const { tablePreferences } = state;
      const { columns, tableName } = action;
      const currentPreference = tablePreferences[tableName];
      if (currentPreference) {
        const newPreferences = {
          ...tablePreferences,
          [tableName]: orderBy(columns, ['position']),
        };
        return { ...state, tablePreferences: newPreferences };
      }
      return state;
    }
    case CUSTOM_META_ADD_NEW_META: {
      const { meta } = action;
      // TODO: update tablePreferences where ever any column using this meta._id!
      const { tablePreferenceMetaData, tablePreferences } = state;
      const type = meta.object_type;
      const newTablePreferenceMetaData = [...tablePreferenceMetaData];
      const objectDefIndex = findIndex(newTablePreferenceMetaData, { type });
      let objectDef = {
        type, custom_fields: [], fields: [], local_fields: [],
      };
      if (objectDefIndex >= 0) {
        objectDef = { ...newTablePreferenceMetaData[objectDefIndex] };
        newTablePreferenceMetaData[objectDefIndex] = objectDef;
      } else {
        newTablePreferenceMetaData.push(objectDef);
      }

      const customFields = [...(objectDef.custom_fields || [])];
      const metaIdx = findIndex(customFields, { _id: meta._id });
      const newMeta = {
        ...meta,
        name: meta._id,
        type: meta.data_type,
      };
      if (metaIdx >= 0) {
        customFields[metaIdx] = newMeta;
      } else {
        customFields.push(newMeta);
      }
      objectDef.custom_fields = customFields;

      const newTablePreferences = reduce(tablePreferences, (items, columns, tableName) => {
        items[tableName] = reduce(columns, (cols, col) => {
          cols.push({
            ...col,
            ...(col.target_custom_meta_id === meta._id ? {
              type: meta.data_type,
              values: meta.values,
              default_value: meta.default_value,
            } : {}),
          });
          return cols;
        }, []);
        return items;
      }, {});

      return {
        ...state,
        tablePreferenceMetaData: newTablePreferenceMetaData,
        tablePreferences: newTablePreferences,
      };
    }
    case LOAD_TABLE_PREFERENCE_META_DATA: {
      return { ...state, tablePreferenceMetaData: action.meta };
    }
    case LOAD_USER_SYNC_PERMISSIONS: {
      const { results, userId } = action;
      return {
        ...state,
        userSyncPermissions: {
          ...state.userSyncPermissions,
          [userId]: results,
        },
      };
    }
    case LOAD_ORGANIZATION_SYNC_PERMISSIONS: {
      const { results, organizationId } = action;
      const orgResults = {
        users: results,
        hasError: false,
        hasWarning: false,
        hasSuccess: false, // if one of the user has success, yes, we can sync
      };
      each(results, (user) => {
        if (user.hasError) {
          orgResults.hasError = true;
        } else {
          orgResults.hasSuccess = true;
        }
        if (user.hasWarning) {
          orgResults.hasWarning = true;
        }
      });


      return {
        ...state,
        organizationSyncPermissions: {
          ...state.organizationSyncPermissions,
          [organizationId]: orgResults,
        },
      };
    }
    case APP_HIDE_SYNC_TOAST: {
      return {
        ...state,
        hideSyncToast: true,
      };
    }
    case APP_UNHIDE_SYNC_TOAST: {
      return {
        ...state,
        hideSyncToast: false,
      };
    }
    case APP_SHOULD_SHOW_SYNC_TOAST: {
      return {
        ...state,
        shouldShowSyncToast: false,
      };
    }
    case APP_SHOULD_HIDE_SYNC_TOAST: {
      return {
        ...state,
        shouldShowSyncToast: true,
      };
    }
    default:
      return state;
  }
};

/* Selectors */

export const getHideSyncToast = state => state.app.hideSyncToast;
export const getShouldShowSyncToast = state => state.app.shouldShowSyncToast;
export const getShowAddPost = state => state.app.showAddPost;
export const getWindowWidth = state => state.app.dimensions.windowWidth;
export const getWindowHeight = state => state.app.dimensions.windowHeight;
export const getHeaderHeight = state => state.app.dimensions.headerHeight;
export const getFooterHeight = state => state.app.dimensions.footerHeight;
export const getIsMobile = state => state.app.dimensions.windowWidth < 768;
export const getContainerWidth = state => state.app.dimensions.containerWidth;
export const getUserPreferences = state => state.app.preferences;
export const getTablePreferences = state => state.app.tablePreferences;
export const getTablePreferenceMetaData = state => state.app.tablePreferenceMetaData;
export const getTablePreference = (state, tableName) => {
  const { tablePreferences } = state.app;
  if (tablePreferences && tablePreferences[tableName]) {
    return tablePreferences[tableName];
  }
  return null;
};

export const getUserSyncPermissions = (state, userId) => {
  const { userSyncPermissions } = state.app;
  return userSyncPermissions[userId];
};

export const getOrganizationSyncPermissions = (state, orgId) => {
  const { organizationSyncPermissions } = state.app;
  return organizationSyncPermissions[orgId];
};


export const getViewableDimensions = (state) => {
  const { dimensions } = state.app;
  const { browser } = state;
  const containerPadding = browser.is.extraSmall ? 0 : 30;
  return {
    width: Math.max(dimensions.containerWidth - containerPadding, 0),
    height: Math.max(dimensions.windowHeight - (dimensions.headerHeight + dimensions.footerHeight), 0),
  };
};

export const getFontSize = (state) => {
  const { preferences } = state.app;
  let fontSize = preferences[USER_PREFERENCE_FONT_SIZE] || FONT_SIZE_NORMAL;
  if (indexOf(FONT_SIZES, fontSize) < 0) {
    fontSize = FONT_SIZE_NORMAL;
  }
  return fontSize;
};
export const getIsFontSizeBig = (state) => {
  const fontSize = getFontSize(state);
  return fontSize === FONT_SIZE_BIG;
};

export const getEnvironment = () => {
  let env = null;
  if (typeof window !== 'undefined') {
    const baseUrl = window.baseUrl || window.location.toString();
    if (baseUrl !== null && baseUrl !== undefined) {
      if (baseUrl.indexOf('trusales-sandbox') > 0) {
        env = 'sandbox';
      } else if (baseUrl.indexOf('ts1') >= 0) {
        env = 'staging';
      } else if (baseUrl.indexOf('localhost') >= 0) {
        env = 'localhost';
      } else if (baseUrl.indexOf('trusales.primary-intel.com') >= 0) {
        env = 'production';
      }
    }
  }
  return env;
};

export const getHasFrontendCookie = () => {
  const c = getCookie();
  return c !== undefined && c !== null;
};

// Export Reducer
export default AppReducer;
